import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { PrivacyPolicy, TermsOfService } from '../LegalLinks';

const TosLinks = () => {
  const { t } = useTranslation();
  return (
    <span>
      <Trans i18nKey="haveReadUnderstandTOSPP" t={t}>
        Foo
        <TermsOfService>Link to terms of service</TermsOfService>
        <PrivacyPolicy>Link to privacy policy</PrivacyPolicy>
      </Trans>
    </span>
  );
};

export default TosLinks;
